

































import { Component, Vue } from "vue-property-decorator";
import { Button, Checkbox, Dialog } from "vant";
import customField from "@/components/customField/index.vue";
import { login } from "@/utils/hybirdMethods";
import { getBrowser } from "@/utils/browser";
import { goBack } from "@/utils/hybirdMethods";
import passwordErrorPrompt from "@/components/passwordErrorPrompt.vue";

const browser = getBrowser();

@Component({
  components: {
    [Button.name]: Button,
    [customField.name]: customField,
    passwordErrorPrompt,
    [Checkbox.name]: Checkbox
  }
})
export default class Login extends Vue {
  form = {
    account: "",
    password: "",
    login_type: 1 //1密码，2短信
  };
  pwdErrPromptOption = {
    show: false,
    errCode: -1,
    errHtml: ''
  }
  checked = false

  created() {
    if (browser.isGetProApp) {
      (this as any).$apis
        .Check_phone({ phone: this.$route.query.phone })
        .then(() => {})
        .catch(err => {
          Dialog.alert({
            title: "提示",
            message: err.msg
          }).then(() => {
            goBack();
          });
        });
    }
  }

  get isDisabledSubmit() {
    return !this.form.account || !this.form.password || !this.checked;
  }

  formatter(value) {
    return value.replace(/ /g, "");
  }

  handDisRoute(){
    this.$router.push('/login-disclaimers')
  }

  handleSubmit() {
    (this as any).$apis
      .login(this.form)
      .then(res => {
        // TODO: 登录错误 Code 100173
        // TODO: 登录错误，冻结 Code 100174
        if(res.code){
          if( res.code === 100174 || res.code === 100173 ){
            this.pwdErrPromptOption.errCode = res.code;
            this.pwdErrPromptOption.errHtml = res.data.err_msg.h5;
            this.pwdErrPromptOption.show = true;
            (this as any).$refs['password-error-prompt-el'].show = true;
            return
          }
        }

        const { token, user_info } = res;
        
        (this as any).$localstorage.set("userInfo", user_info);
        sessionStorage.setItem("token", token);
        if (browser.isGetProApp) {
          this.$router.push({
            path: "/mode-select"
          });
        } else if (browser.isApp) {
          login(res);
        } else {
          this.$router.go(-1);
        }
      })
      .catch(e => {
        
      });
  }
  passwordErrorPromptConfirm(errCode){
    (this as any).pwdErrPromptOption.show = false;
    if(errCode === 100173){
      (this as any).form.password = '';
      (this as any).$refs['custom-field-password'].setInputFocus()
    }
  }
}
